import { apiRequest } from '@/config/axios/axios'

export const fetchTariffAddons = (params) => {
  return apiRequest.get(`addons/category?addonCategory=${params.addon}&segmentGroup=${params.segment}`)
}
